import { Box, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/Index";
import PropTypes from "prop-types";
import { tokens } from "../../../../../theme";

interface Props {
  doneComments: number;
  physicalComments: number;
}

export const TableRowScannedComments: React.FC<Props> = ({
  doneComments,
  physicalComments,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, reduxTheme);

  const coloredBarPercentage = (
    done: number,
    total: number
  ): string => {
    if (total === 0) {
      return "0%";
    }
    const percentage = Math.floor((done / total) * 100);
    return `${percentage}%`;
  };

  // If no physical comments assigned, show N/A
  if (!physicalComments || physicalComments === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        N/A
      </Typography>
    );
  }

  const percentage = Math.floor((doneComments / physicalComments) * 100);
  const isComplete = percentage === 100;

  return (
    <>
      <Typography 
        variant="body1"
        sx={{
          fontWeight: isComplete ? 'bold' : 'normal',
          color: isComplete ? 'success.main' : 'text.primary'
        }}
      >
        {`${doneComments}/${physicalComments}`}
      </Typography>
      <Box
        sx={{
          backgroundColor: colors.primary[800],
          height: 10,
          width: "100%",
          borderRadius: 30,
          mt: 1,
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: coloredBarPercentage(doneComments, physicalComments),
            borderRadius: 30,
            bgcolor: isComplete ? 'success.main' : colors.primary[400],
            transition: 'width 0.3s ease, background-color 0.3s ease',
          }}
        ></Box>
      </Box>
    </>
  );
};

TableRowScannedComments.propTypes = {
  doneComments: PropTypes.number.isRequired,
  physicalComments: PropTypes.number.isRequired,
};